export const createBudgetsAPI = (request) => ({
  getBudget: (teamId) => 
    request(`/team-budget-get/${teamId}`, {
      method: 'GET'
    }),
  
  updateBudget: (teamId, data) =>
    request(`/team-budget-update/${teamId}`, {
      method: 'PUT',
      body: JSON.stringify({ data })
    })
}); 